import { FadeIn, ChapterHeading } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const WhatIsKrug = () => {
  const { t } = useLang();
  const KRUG_CARDS = t.cards;
  return (
  <section id="kako-radi" data-testid="what-is-krug" className="bg-krug-mist py-24 md:py-32 relative overflow-hidden">
    <div className="absolute top-0 right-0 w-[380px] h-[380px] rounded-full bg-krug-teal/20 blur-[120px]" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <ChapterHeading
        number="01"
        eyebrow={t.whatIs.eyebrow}
        dark={false}
        title={t.whatIs.title}
        copy={t.whatIs.copy}
      />

      <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
        {KRUG_CARDS.map((card, i) => (
          <FadeIn key={card.title} delay={i * 0.09} className={i % 2 === 1 ? 'md:mt-10' : ''}>
            <article
              data-testid={`krug-card-${card.title.toLowerCase()}`}
              className="group h-full rounded-3xl border border-krug-navy/10 bg-white p-8 md:p-10 shadow-[0_24px_60px_-34px_rgba(10,21,38,0.35)] hover:border-krug-gold/70 transition-colors duration-500"
            >
              <div className="flex items-start justify-between">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-krug-teal/20 to-krug-gold/15 text-krug-teal group-hover:scale-105 transition-transform duration-500">
                  <card.icon size={26} />
                </span>
                <span className="font-heading text-5xl font-extrabold text-krug-navy/[0.07] group-hover:text-krug-gold/40 transition-colors duration-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-7 font-heading text-2xl font-extrabold text-krug-navy">{card.title}</h3>
              <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed">{card.copy}</p>
              <ul className="mt-6 flex flex-wrap gap-2">
                {card.preview.map((p) => (
                  <li
                    key={p}
                    className="rounded-full border border-krug-navy/10 bg-krug-navy/[0.04] px-3.5 py-1.5 text-xs font-medium text-slate-600"
                  >
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
  );
};
